import Loadable from "react-loadable";

import { URL_PATH } from "../constants";
import MainLoader from "../app/components/general/MainLoader";

const Maintenance = Loadable({
  loader: () => import("../app/Maintenance"),
  loading: MainLoader,
});
const Product = Loadable({
  loader: () => import("../app/components/landing/Product"),
  loading: MainLoader,
});
const PageNotFound = Loadable({
  loader: () => import("../app/components/landing/PageNotFound"),
  loading: MainLoader,
});
const InformationDetail = Loadable({
  loader: () => import("../app/components/landing/Information"),
  loading: MainLoader,
});
const NavDividend = Loadable({
  loader: () => import("../app/components/landing/NavDividend"),
  loading: MainLoader,
});
const SubscribeValidate = Loadable({
  loader: () => import("../app/components/landing/SubscribeValidate"),
  loading: MainLoader,
});
const RemoveSubscribeValidate = Loadable({
  loader: () => import("../app/components/landing/RemoveSubscribeValidate"),
  loading: MainLoader,
});
const ProductSubscribeValidate = Loadable({
  loader: () =>
    import(
      "../app/components/landing/SubscribeValidate/ProductSubscribeValidate"
    ),
  loading: MainLoader,
});
const PrivacyPolicy = Loadable({
  loader: () => import("../app/components/landing/PrivacyPolicy"),
  loading: MainLoader,
});
const myAccount = Loadable({
  loader: () => import("../app/components/landing/Investor"),
  loading: MainLoader,
});


// Creation Component
const CreationComponent = Loadable({
  loader: () => import("../app/components/landing/Product/CreationComponent"),
  loading: MainLoader,
});

const CashComponent = Loadable({
  loader: () => import("../app/components/landing/Product/CashComponent"),
  loading: MainLoader,
});

const Scheme = Loadable({
  loader: () => import("../app/components/landing/Product/Scheme"),
  loading: MainLoader,
});

const Favorites = Loadable({
  loader: () => import("../app/components/landing/Product/Favorites"),
  loading: MainLoader,
});

const Careers = Loadable({
  loader: () => import("../app/components/landing/Careers"),
  loading: MainLoader,
});
const ContactUs = Loadable({
  loader: () => import("../app/components/landing/ContactUs"),
  loading: MainLoader,
});
const Sitemap = Loadable({
  loader: () => import("../app/components/landing/Sitemap"),
  loading: MainLoader,
});
// const Whatsapp = Loadable({
//   loader: () => import("../app/components/landing/WhatsappJourney"),
//   loading: MainLoader,
// });
const CookiePolicy = Loadable({
  loader: () => import("../app/components/landing/CookiePolicy"),
  loading: MainLoader,
});

const UpdatesNotifications = Loadable({
  loader: () => import("../app/components/landing/UpdatesAndNotification"),
  loading: MainLoader,
});
const MfBytes = Loadable({
  loader: () => import("../app/components/landing/MfBytes"),
  loading: MainLoader,
});
const ETF = Loadable({
  loader: () => import("../app/components/landing/ProductSolutions/ETF"),
  loading: MainLoader,
});
const Rebalancing = Loadable({
  loader: () => import("../app/components/landing/Product/Rebalancing"),
  loading: MainLoader,
});
// Start About US
const AboutUsNew = Loadable({
  loader: () => import("../app/components/landing/AboutUs/index"),
  loading: MainLoader,
});
const CorporateProfile = Loadable({
  loader: () =>
    import("../app/components/landing/AboutUs/CorporateProfile/index"),
  loading: MainLoader,
});
const CorporateGovernance = Loadable({
  loader: () =>
    import("../app/components/landing/AboutUs/CorporateGovernance/index"),
  loading: MainLoader,
});
const FinancialInformation = Loadable({
  loader: () =>
    import("../app/components/landing/AboutUs/FinancialInformation/index"),
  loading: MainLoader,
});
const MediaCenter = Loadable({
  loader: () => import("../app/components/landing/AboutUs/MediaCenter/index"),
  loading: MainLoader,
});
const LeadershipProfile = Loadable({
  loader: () =>
    import("../app/components/landing/AboutUs/LeadershipProfile/index"),
  loading: MainLoader,
});
// End About US
// Learners Corners Start

const LearnersCorners = Loadable({
  loader: () => import("../app/components/landing/LearnersCorner"),
  loading: MainLoader,
});

const LearnerFinencialAwareness = Loadable({
  loader: () =>
    import("../app/components/landing/LearnersCorner/FinencialAwareness/index"),
  loading: MainLoader,
});

const InvestorAwarenessProgram = Loadable({
  loader: () =>
    import("../app/components/landing/LearnersCorner/InvestorAwarenessProgram"),
  loading: MainLoader,
});

const LearnersCornersVideos = Loadable({
  loader: () => import("../app/components/landing/LearnersCorner/Videos/index"),
  loading: MainLoader,
});
const LearnersCornersVideosdetails = Loadable({
  loader: () => import("../app/components/landing/LearnersCorner/Videos/VideosDetail"),
  loading: MainLoader,
});
const LearnersCornersPodcasts = Loadable({
  loader: () => import("../app/components/landing/LearnersCorner/Podcasts"),
  loading: MainLoader,
});
const LearnersCornersPodcastDetails = Loadable({
  loader: () => import("../app/components/landing/LearnersCorner/Podcasts/PodcastDetail"),
  loading: MainLoader,
});
const LearnersCornersimpactInflations = Loadable({
  loader: () =>
    import(
      "../app/components/landing/LearnersCorner/Calculators/ImpactofInflation"
    ),
  loading: MainLoader,
});
const LearnersCornersSipCalculators = Loadable({
  loader: () =>
    import(
      "../app/components/landing/LearnersCorner/Calculators/SipCalculators"
    ),
  loading: MainLoader,
});
const LearnersCornersPresentValues = Loadable({
  loader: () =>
    import(
      "../app/components/landing/LearnersCorner/Calculators/PresentValues"
    ),
  loading: MainLoader,
});

const LearnersCornersGoalSip = Loadable({
  loader: () =>
    import("../app/components/landing/LearnersCorner/Calculators/GoalSip"),
  loading: MainLoader,
});

const LearnersCornersTopUpSip = Loadable({
  loader: () =>
    import("../app/components/landing/LearnersCorner/Calculators/TopUpSip"),
  loading: MainLoader,
});
const LearnersCornersStpCalculator = Loadable({
  loader: () =>
    import(
      "../app/components/landing/LearnersCorner/Calculators/STPCalculator"
    ),
  loading: MainLoader,
});
const LearnersCornersSwapCalculators = Loadable({
  loader: () =>
    import(
      "../app/components/landing/LearnersCorner/Calculators/SWAPCalculator"
    ),
  loading: MainLoader,
});
const LearnersCornersRetirementCalculator = Loadable({
  loader: () =>
    import(
      "../app/components/landing/LearnersCorner/Calculators/RetirementCalculator"
    ),
  loading: MainLoader,
});
const LearnersCornersCostOfChildEducation = Loadable({
  loader: () =>
    import(
      "../app/components/landing/LearnersCorner/Calculators/CostOfChildEducation"
    ),
  loading: MainLoader,
});
const LearnersCornersDreamSip = Loadable({
  loader: () =>
    import("../app/components/landing/LearnersCorner/Calculators/DreamSip"),
  loading: MainLoader,
});
const LearnersTools = Loadable({
  loader: () => import("../app/components/landing/LearnersCorner/Calculators"),
  loading: MainLoader,
});
const BookReview = Loadable({
  loader: () => import("../app/components/landing/LearnersCorner/BookReview/index"),
  loading: MainLoader,
});
//learners information start
const BeginnerDetailInfo = Loadable({
  loader: () => import("../app/components/landing/BeginnerInformation"),
  loading: MainLoader,
});
const IntermediateDetailInfo = Loadable({
  loader: () => import("../app/components/landing/IntermediateInformation"),
  loading: MainLoader,
});
const AdvanceDetailInfo = Loadable({
  loader: () => import("../app/components/landing/AadvancedInformation"),
  loading: MainLoader,
});
const BookreviewInformation = Loadable({
  loader: () => import("../app/components/landing/BookreviewInformation"),
  loading: MainLoader,
});
const ReadingRoom = Loadable({
  loader: () => import("../app/components/landing/LearnersCorner/TheReadingRoom/index"),
  loading: MainLoader,
});
const Poetrysec = Loadable({
  loader: () => import("../app/components/landing/LearnersCorner/Poetrysec/index"),
  loading: MainLoader,
});
//learners information end
// Learners Corners End

// Start product solution New
const ProductSolutions = Loadable({
  loader: () => import("../app/components/landing/ProductSolutions"),
  loading: MainLoader,
});

const CompareFunds = Loadable({
  loader: () =>
    import("../app/components/landing/ProductSolutions/CompareFunds"),
  loading: MainLoader,
});

const CompareFundsDetails = Loadable({
  loader: () =>
    import("../app/components/landing/ProductSolutions/CompareFundsDetails"),
  loading: MainLoader,
});

const ProductOverview = Loadable({
  loader: () =>
    import("../app/components/landing/ProductSolutions/ProductOverview"),
  loading: MainLoader,
});
const NfoOverview = Loadable({
  loader: () =>
    import("../app/components/landing/ProductSolutions/NfoOverview"),
  loading: MainLoader,
});
const ProductIndexFund = Loadable({
  loader: () => import('../app/components/landing/ProductSolutions/ProductIndexFund'),
  loading: MainLoader
});
const FlexiCapPromotion = Loadable({
  loader: () =>
    import("../app/components/landing/ProductSolutions/FlexiCapPromotion"),
  loading: MainLoader,
}); 
const FlexiCapPromotionQuicklink = Loadable({
  loader: () =>
    import("../app/components/landing/ProductSolutions/FlexiCapPromotionQuickLink"),
  loading: MainLoader,
});
// End product solution New


//StatutoryDisclosure start

const StatutoryDisclosure = Loadable({
  loader: () => import("../app/components/landing/StatutoryDisclosure/index"),
  loading: MainLoader,
});

const MandatoryInvestmentByAMC = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/MandatoryInvestmentByAMC/index"
    ),
  loading: MainLoader,
});

const DisclosureOfVariousPayment = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/DisclosureofVariousPayment/index"
    ),
  loading: MainLoader,
});
const DisclosureofDesignatedEmployees = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/DisclosureofDesignatedEmployees/index"
    ),
  loading: MainLoader,
});

const DisclosureofVariousPurpose = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/DisclosureOfVariousPurpose/index"
    ),
  loading: MainLoader,
});

const ReportOfComplianceOfStewardshipCode = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/ReportOfComplianceOfStewardshipCode/index"
    ),
  loading: MainLoader,
});
const RationaleforDeviation = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/RationaleforDeviation/index"
    ),
  loading: MainLoader,
});

const AnnualDisclosureofRiskometers = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/AnnualDisclosureofRiskometers/index"
    ),
  loading: MainLoader,
});

const AnnualReport = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/AnnualReport/index"
    ),
  loading: MainLoader,
});
const Abridged = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/Abridged/index"
    ),
  loading: MainLoader,
});
const SchemeFinancials = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/SchemeFinancials/index"
    ),
  loading: MainLoader,
});
const MonthlyPortfolioNEW = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/MonthlyPortfolioNEW/index"
    ),
  loading: MainLoader,
});
const AveragePortfolio = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/AveragePortfolio/index"
    ),
  loading: MainLoader,
});
const Aum = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/Aum/index"
    ),
  loading: MainLoader,
});
const Trade = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/Trade/index"
    ),
  loading: MainLoader,
});

const Comission = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/Comission/index"
    ),
  loading: MainLoader,
});
const UnclaimedDividendRedemptionNew = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/UnclaimedDividendRedemptionNew/index"
    ),
  loading: MainLoader,
});
const TotalExpenseRatioOfMurualFundSchemes = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/TotalExpenseRatioOfMurualFundSchemes/index"
    ),
  loading: MainLoader,
});
const TrackingErrorNew = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/TrackingErrorNew/index"
    ),
  loading: MainLoader,
});
const Voting = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/Voting/index"
    ),
  loading: MainLoader,
});
const StewardshipReport = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/StewardshipReport/index"
    ),
  loading: MainLoader,
});
const Remunerationnew = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/Remuneration/index"
    ),
  loading: MainLoader,
});
const SchemePerformancenew = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/SchemePerformance/index"
    ),
  loading: MainLoader,
});

const InvestorComplaints = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/InvestorComplaints/index"
    ),
  loading: MainLoader,
});
const InvestorComplaintsPms = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/InvestorComplaintsPms/index"
    ),
  loading: MainLoader,
});
const Complaints = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/Complaints/index"
    ),
  loading: MainLoader,
});
const LetterUnitholder = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/LetterUnitholder/index"
    ),
  loading: MainLoader,
});
const PublicCautionNew = Loadable({
  loader: () =>
    import(
      "../app/components/landing/StatutoryDisclosure/PublicCaution/index"
    ),
  loading: MainLoader,
});
const OfferDocuments = Loadable({
  loader: () =>
    import("../app/components/landing/StatutoryDisclosure/OfferDocuments/index"),
  loading: MainLoader,
});
const AdvisoryDisclosure = Loadable({
  loader: () =>
    import("../app/components/landing/StatutoryDisclosure/AdvisoryDisclosure/index"),
  loading: MainLoader,
});
const DistributorCommission = Loadable({
  loader: () =>
    import("../app/components/landing/StatutoryDisclosure/DistributorCommission/index"),
  loading: MainLoader,
});
const MarketMakers = Loadable({
  loader: () =>
    import("../app/components/landing/StatutoryDisclosure/MarketMakers/index"),
  loading: MainLoader,
});
const Disclosurenew = Loadable({
  loader: () => import("../app/components/landing/StatutoryDisclosure/Disclosurenewmonthly/index"),
  loading: MainLoader,
});
const RiskAdjustedReturn = Loadable({
  loader: () => import("../app/components/landing/StatutoryDisclosure/RiskAdjustedReturn/index"),
  loading: MainLoader,
});
const ReportOnMisselling = Loadable({
  loader: () => import("../app/components/landing/StatutoryDisclosure/ReportOnMisselling/index"),
  loading: MainLoader,
});
const StatutoryInfoDetail = Loadable({
  loader: () => import("../app/components/landing/StatutoryInformation"),
  loading: MainLoader,
});
//StatutoryDisclosure end

//Distributor Corner start

const DistributorCornerNew = Loadable({
  loader: () =>
    import(
      "../app/components/landing/DistributorCorner/index"
    ),
  loading: MainLoader,
});
const BeingaMFD = Loadable({
  loader: () =>
    import(
      "../app/components/landing/DistributorCorner/BeingaMFD/index"
    ),
  loading: MainLoader,
});

const OnboardDigitally = Loadable({
  loader: () =>
    import(
      "../app/components/landing/DistributorCorner/OnboardDigitally/index"
    ),
  loading: MainLoader,
});

const FormsDisclosures = Loadable({
  loader: () =>
    import(
      "../app/components/landing/DistributorCorner/FormsDisclosures/index"
    ),
  loading: MainLoader,
});

const KnowledgeCentre = Loadable({
  loader: () =>
    import(
      "../app/components/landing/DistributorCorner/KnowledgeCentre/index"
    ),
  loading: MainLoader,
});
const FAQs = Loadable({
  loader: () =>
    import(
      "../app/components/landing/DistributorCorner/FAQs/index"
    ),
  loading: MainLoader,
});
const SebiCodeofConduct = Loadable({
  loader: () =>
    import(
      "../app/components/landing/DistributorCorner/FormsDisclosures/SebiCodeofConduct/index"
    ),
  loading: MainLoader,
});
const HandBook = Loadable({
  loader: () =>
    import(
      "../app/components/landing/DistributorCorner/HandBook/index"
    ),
  loading: MainLoader,
});
const HandBookDetail = Loadable({
  loader: () =>
    import(
      "../app/components/landing/DistributorCorner/HandBook/Flipbook"
    ),
  loading: MainLoader,
});
const DistributorInfoDetail = Loadable({
  loader: () => import("../app/components/landing/DistributorCornerInformation"),
  loading: MainLoader,
});
//Distributor Corner end

//Start Investor Service

const InvestorServices = Loadable({
  loader: () => import("../app/components/landing/InvestorServices/index"),
  loading: MainLoader,
});

const FormsandDisclosures = Loadable({
  loader: () =>
    import("../app/components/landing/InvestorServices/FormsandDisclosures"),
  loading: MainLoader,
});

const OurOnlineServices = Loadable({
  loader: () =>
    import("../app/components/landing/InvestorServices/OurOnlineServices"),
  loading: MainLoader,
});

const AdditionalFundInformation = Loadable({
  loader: () =>
    import(
      "../app/components/landing/InvestorServices/FundRelatedDetails/AdditionalFundInformation"
    ),
  loading: MainLoader,
});


const Factsheets = Loadable({
  loader: () =>
    import(
      "../app/components/landing/InvestorServices/FundRelatedDetails/Factsheets"
    ),
  loading: MainLoader,
});

const FundDocuments = Loadable({
  loader: () =>
    import(
      "../app/components/landing/InvestorServices/FundRelatedDetails/FundDocuments"
    ),
  loading: MainLoader,
});

const FundLiteratures = Loadable({
  loader: () =>
    import(
      "../app/components/landing/InvestorServices/FundRelatedDetails/FundLiteratures"
    ),
  loading: MainLoader,
});

const InvestorMarketUpdate = Loadable({
  loader: () =>
    import(
      "../app/components/landing/InvestorServices/InvestorMarketUpdate/index"
    ),
  loading: MainLoader,
});
const MarketVideoDetail = Loadable({
  loader: () =>
    import(
      "../app/components/landing/InvestorServices/InvestorMarketUpdate/VideoDetail"
    ),
  loading: MainLoader,
});
const InvestorFaq = Loadable({
  loader: () =>
    import("../app/components/landing/InvestorServices/InvestorFaq/index"),
  loading: MainLoader,
});
const SchemeCollectionAccount = Loadable({
  loader: () =>
    import("../app/components/landing/InvestorServices/SchemeAccount/index"),
  loading: MainLoader,
});
const WeeklyPortfolioDetails = Loadable({
  loader: () =>
    import("../app/components/landing/InvestorServices/WeeklyPortfolio/index"),
  loading: MainLoader,
});
const InvestorServiceInfoDetail = Loadable({
  loader: () => import("../app/components/landing/InvestorServicesInformation"),
  loading: MainLoader,
});

//End Investor Service

//Knowledge Stack start
const KnowledgeStack = Loadable({
  loader: () =>
    import(
      "../app/components/landing/KnowledgeStack/index"
    ),
  loading: MainLoader,
});

const NewMDCeoDesk = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/NewMDCeoDesk/index"),
  loading: MainLoader,
});

// const Articles = Loadable({
//   loader: () => import("../app/components/landing/KnowledgeStack/NewMDCeoDesk/MDSpeaks/Articles"),
//   loading: MainLoader,
// });

// const Videos = Loadable({
//   loader: () => import("../app/components/landing/KnowledgeStack/NewMDCeoDesk/MDSpeaks/Videos/index"),
//   loading: MainLoader,
// });
const MdspeakVideosDetail = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/NewMDCeoDesk/MDSpeaks/Videos/VideosDetail"),
  loading: MainLoader,
});
// const InterviewArticles = Loadable({
//   loader: () => import("../app/components/landing/KnowledgeStack/NewMDCeoDesk/MediConversations/InterviewArticles"),
//   loading: MainLoader,
// });

// const InterviewVideos = Loadable({
//   loader: () => import("../app/components/landing/KnowledgeStack/NewMDCeoDesk/MediConversations/InterviewVideos/index"),
//   loading: MainLoader,
// });
// const InterviewVideosDetail = Loadable({
//   loader: () => import("../app/components/landing/KnowledgeStack/NewMDCeoDesk/MediConversations/InterviewVideos/VideosDetail"),
//   loading: MainLoader,
// });

const MarketReview = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/MarketReview"),
  loading: MainLoader,
});

const CreditPolicy = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/CreditPolicy"),
  loading: MainLoader,
});

const MFYearbook = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/MFYearbook"),
  loading: MainLoader,
});

const TuesdayTalkingPoint = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/TuesdayTalkingPoint"),
  loading: MainLoader,
});

const ChartScope = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/ChartScope"),
  loading: MainLoader,
});
const MfInsights = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/MfInsights"),
  loading: MainLoader,
});

const WeekendBytes = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/WeekendBytes"),
  loading: MainLoader,
});

const Musings = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/Musings"),
  loading: MainLoader,
});

const SalesHandbook = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/SalesHandbook"),
  loading: MainLoader,
});

const Webinars = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/Webinars"),
  loading: MainLoader,
});
const WebinarDetail = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/Webinars/WebinarDetail"),
  loading: MainLoader,
});

const VideoList = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/Videos"),
  loading: MainLoader,
});

const Podcasts = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/Podcasts"),
  loading: MainLoader,
});

const BehaviouralBlogs = Loadable({
  loader: () => import("../app/components/landing/KnowledgeStack/BehaviouralBlogs"),
  loading: MainLoader,
});

//detail
const TalkingDetailInfo = Loadable({
  loader: () => import("../app/components/landing/TalkingpointInformartion"),
  loading: MainLoader,
});
const WeekendDetailInfo = Loadable({
  loader: () => import("../app/components/landing/WeekendbytesInformartion"),
  loading: MainLoader,
});
const MonthlyDetailInfo = Loadable({
  loader: () => import("../app/components/landing/MonthlyMusingInformartion"),
  loading: MainLoader,
});
const CreditPolicyDetailInfo = Loadable({
  loader: () => import("../app/components/landing/CreditPolicyInformartion"),
  loading: MainLoader,
});
const MdspeakarticleDetailInfo = Loadable({
  loader: () => import("../app/components/landing/MdSpeakArticleInformation"),
  loading: MainLoader,
});
const BehaviouralBlogDetailInfo = Loadable({
  loader: () => import("../app/components/landing/BehaviouralBlogInformartion"),
  loading: MainLoader,
});
const MarketReviewDetailInfo = Loadable({
  loader: () => import("../app/components/landing/MarketReviewInformation"),
  loading: MainLoader,
});

//Knowledge Stack end
//Goal Marketing start
const GoalMarketing = Loadable({
  loader: () => import("../app/components/landing/GoalMarketing/index"),
  loading: MainLoader,
});
//Goal Marketing end
//IAP Page start
const IAPPage = Loadable({
  loader: () => import("../app/components/landing/IAPPage/index"),
  loading: MainLoader,
});
//IAP Page End
//GlossarySec start
const GlossarySec = Loadable({
  loader: () => import("../app/components/landing/Glossary/index"),
  loading: MainLoader,
});
//GlossarySec end
//IAP Women start
const IAPWomenEnglish = Loadable({
  loader: () => import("../app/components/landing/IAPWomen/English/index"),
  loading: MainLoader,
});
const EmailPopup = Loadable({
  loader: () => import("../app/components/landing/IAPWomen/EmailPopup/index"),
  loading: MainLoader,
});
const EmailPopupEvents = Loadable({
  loader: () => import("../app/components/landing/IAPWomen/QuizEvent/index"),
  loading: MainLoader,
});
const EmailPopupHindi = Loadable({
  loader: () => import("../app/components/landing/IAPWomen/EmailPopupHindi/index"),
  loading: MainLoader,
});
const IAPWomenRegistration = Loadable({
  loader: () => import("../app/components/landing/IAPWomen/Registration/index"),
  loading: MainLoader,
});
const IAPQuizRegistration = Loadable({
  loader: () => import("../app/components/landing/IAPWomen/RegistrationQuiz/index"),
  loading: MainLoader,
});
//IAP Women end
// Survey Start
const SurveyFT = Loadable({
  loader: () => import("../app/components/landing/Survey/FinancialTransaction"),
  loading: MainLoader,
});
const SurveyNFT = Loadable({
  loader: () => import("../app/components/landing/Survey/NonFinancialTransaction"),
  loading: MainLoader,
});
const SurveyPartner = Loadable({
  loader: () => import("../app/components/landing/Survey/PartnerSurvey"),
  loading: MainLoader,
});
// Jan Nivesh Start
const JanNivesh = Loadable({
  loader: () => import("../app/components/landing/JanNivesh/index"),
  loading: MainLoader,
});
// Jan Nivesh End
//youtubeshorts start
const HomeYoutubeShorts = Loadable({
  loader: () => import("../app/components/landing/HomepageNew/Shortspage"),
  loading: MainLoader,
});
//youtubeshorts end
const HomePageNew = Loadable({
  loader: () => import("../app/components/landing/HomepageNew"),
  loading: MainLoader,
});
const Goals = Loadable({
  loader: () => import("../app/components/landing/ProductSolutions/Goals"),
  loading: MainLoader,
});
const RiskProfiler = Loadable({
  loader: () =>
    import("../app/components/landing/ProductSolutions/RiskProfile"),
  loading: MainLoader,
});
const InvestmentBasketDetail = Loadable({
  loader: () =>
    import("../app/components/landing/ProductSolutions/BasketDetails"),
  loading: MainLoader,
});
const AccountStatement = Loadable({
  loader: () => import("../app/components/landing/AccountStatement"),
  loading: MainLoader,
});
const SipLanding = Loadable({
  loader: () => import("../app/components/landing/Learn/Sip"),
  loading: MainLoader,
});
// Important Announcement start
const ImmportantAnnouncement = Loadable({
  loader: () => import("../app/components/landing/HomepageNew/ImmportantAnnouncement/index"),
  loading: MainLoader,
});
// Important Announcement end
//OneSpan start
const OneSpan = Loadable({
  loader: () => import("../app/components/landing/OneSpan/index"),
  loading: MainLoader,
});
//OneSpan end

import { getInformationDetailContent } from "../app/components/landing/Information/actions";
import { getCareerContent } from "../app/components/landing/Careers/actions";
import { getSitemapContent } from "../app/components/landing/Sitemap/actions";
import { getCookiePolicyContent } from "../app/components/landing/CookiePolicy/actions";
import { getContactUsContent } from "../app/components/landing/ContactUs/actions";
import {
  getAboutUsFinancialInfo,
} from "../app/components/landing/AboutUs/actions";
import { getNavDividendContent } from "../app/components/landing/NavDividend/actions";
import { getStaticPageContent } from "../app/components/landing/PrivacyPolicy/actions";
import {
  getProductList,
  getFiltersContent,
} from "../app/components/landing/Product/actions";
import { getSchemeContent } from "../app/components/landing/Product/Scheme/actions";
import { getCreationContent,getRebalancingData } from "../app/components/landing/Product/CreationComponent/actions";
// import { getWhatsAppService } from "../app/components/landing/WhatsappJourney/action";

import {
  getAllFundProducts,
  getAllFundProductsFilters,
  getNfoList, getSingleFundDetails, allSectionsMeta,getNfoOverview
} from "../app/components/landing/ProductSolutions/actions";

import { getStatutoryInfoDetailContent } from "../app/components/landing/StatutoryInformation/actions";
import { learnCornerLevels} from "../app/components/landing/LearnersCorner/actions";
import {BeginnerDetail} from "../app/components/landing/BeginnerInformation/actions";
import {IntermediateDetail} from "../app/components/landing/IntermediateInformation/actions";
import {AdvanceDetail} from "../app/components/landing/AadvancedInformation/actions";
import { getDistributorInfoDetailContent } from "../app/components/landing/DistributorCornerInformation/actions";
import {getCalculatorMetaData, getBookReview, cornerVideodetailApi, getCornerPodcastDetails} from "../app/components/landing/LearnersCorner/actions";
import {getBookReviewDetails} from "../app/components/landing/BookreviewInformation/actions";
import { getInvestorFaq, getMarketVideoDetail } from "../app/components/landing/InvestorServices/actions";
import { getInvestorInfoDetailContent } from "../app/components/landing/InvestorServicesInformation/actions";
//knowledge stack start
import {mdVideosDetails, getKnowledgestackHandbook,getWebinarDetail} from "../app/components/landing/KnowledgeStack/actions";
import {getKnowledgestackTalkingDetail} from "../app/components/landing/TalkingpointInformartion/actions";
import {getKnowledgestackWeekendBytesDetail} from "../app/components/landing/WeekendbytesInformartion/actions";
import {getKnowledgestackMonthlyMusingDetail} from '../app/components/landing/MonthlyMusingInformartion/actions';
import {getKnowledgestackCreaditPolicyDetail} from '../app/components/landing/CreditPolicyInformartion/actions';
import {getMDSpeakArticleDetail} from '../app/components/landing/MdSpeakArticleInformation/actions';
import {getKnowledgestackBehaviouralBlog} from '../app/components/landing/BehaviouralBlogInformartion/actions';
import { getMarketReviewDetail } from "../app/components/landing/MarketReviewInformation/actions";
//knowledge stack end
import {getHandBookDetails} from "../app/components/landing/DistributorCorner/actions";
import { iapPageData } from "../app/components/landing/IAPPage/action";
import {SurveyUser} from "../app/components/landing/Survey/actions";
import {getYoutubeShorts} from "../app/components/landing/HomepageNew/action";

export default [
  {
    path: `${URL_PATH.NAV_AND_DIVIDEND}`,
    component: NavDividend,
    exact: true,
    loadData: [getNavDividendContent],
  },
  {
    path: `${URL_PATH.CALCULATE_CREATION_COMPONENT}`,
    component: CreationComponent,
    exact: true,
    loadData: [getCreationContent],
  },
  {
    path: `${URL_PATH.REBALANCING_COMPONENT}`,
    component: Rebalancing,
    exact: true,
    loadData: [getRebalancingData],
  },

  {
    path: `${URL_PATH.WEALTH_CREATION}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.RETIREMENT_PLANNING}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.RETIREMENT_FUND}`,
    component: Product,
    exact: true,
    loadData: [getProductList],
  },
  {
    path: `${URL_PATH.CHILDREN_FUND}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.TAX_SAVING}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.INCOME_SOLUTIONS}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.CAT_DIVERSE}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.CAT_GOLD_ETF}`,
    component: Product,
    exact: true,
    loadData: [getProductList],
  },
  {
    path: `${URL_PATH.CAT_INDEX}`,
    component: ProductIndexFund,
    exact: true,
  },
  {
    path: `${URL_PATH.CAT_ETF}`,
    component: ETF,
    exact: true,
  },
  {
    path: `${URL_PATH.CAT_NFO}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getNfoList],
  },
  {
    path: `${URL_PATH.CAT_FUND_OF_FUNDS}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.CAT_THEMATIC_SECTORAL_EQUITY}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.CAT_SOLUTION_ORIENTED}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.CAT_THEMATIC_EQ}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.CAT_THEME_BASED}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.CAT_DURATION_BASED}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.CAT_HYBRID}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.CAT_ELSS}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts],
  },
  {
    path: `${URL_PATH.PRODUCT_SCHEME}`,
    component: Scheme,
    exact: true,
    loadData: [getSchemeContent],
  },
  {
    path: `${URL_PATH.GOLD_CASH_COMPONENT}`,
    component: CashComponent,
    // exact: true,
    loadData: [],
  },
  {
    path: `${URL_PATH.SILVER_CASH_COMPONENT}`,
    component: CashComponent,
    // exact: true,
    loadData: [],
  },
  {
    path: `${URL_PATH.OUR_PRODUCTS}`,
    component: Product,
    exact: true,
    loadData: [getProductList, getFiltersContent],
  },
  {
    path: `${URL_PATH.STATUTORY_INFORMATION}`,
    component: InformationDetail,
    exact: true,
    loadData: [getInformationDetailContent],
  },
  {
    path: `${URL_PATH.INFORMATION}`,
    component: InformationDetail,
    exact: true,
    loadData: [getInformationDetailContent],
  },
  {
    // cookie is there hence no ssr
    path: `${URL_PATH.FAVORITES}`,
    component: Favorites,
    exact: true,
    loadData: [],
  },
  {
    path: `${URL_PATH.CAREERS}`,
    component: Careers,
    exact: true,
    loadData: [getCareerContent],
  },
  {
    path: `${URL_PATH.PRIVACY_POLICY}`,
    component: PrivacyPolicy,
    loadData: [getStaticPageContent],
  },
  {
    path: `${URL_PATH.TERMS_AND_CONDITIONS}`,
    component: PrivacyPolicy,
    loadData: [getStaticPageContent],
  },
  {
    path: `${URL_PATH.DISCLAIMER}`,
    component: PrivacyPolicy,
    loadData: [getStaticPageContent],
  },
  {
    path: `${URL_PATH.MY_ACCOUNT}`,
    component: myAccount,
  },
  {
    //need to test when integrated meta
    path: `${URL_PATH.SITEMAP}`,
    component: Sitemap,
    loadData: [getSitemapContent],
  },
  {
    path: `${URL_PATH.COOKIE_POLICY}`,
    component: CookiePolicy,
    exact: true,
    loadData: [getCookiePolicyContent],
  },
  {
    path: `${URL_PATH.CONTACT_US}`,
    component: ContactUs,
    loadData: [getContactUsContent],
  },
  // {
  //   path: `${URL_PATH.DEFAULT}`,
  //   component: Homepage,
  //   exact: true,
  //   loadData: [getHome],
  // },
  {
    path: `${URL_PATH.DEFAULT}`,
    component: HomePageNew,
    exact: true,
  },
  
  {
    //no ssr required in this
    path: `${URL_PATH.REMOVE_SUBSCRIBE_VALIDATE}`,
    component: RemoveSubscribeValidate,
    exact: false,
  },
  // {//need to see as on each page new request is going
  //     path: `${URL_PATH.INFORMATION}`,
  //     component: InformationDetail,
  //     loadData: [getInformationDetailContent]
  // },
  {
    //no ssr required in this
    path: `${URL_PATH.SUBSCRIBEVALIDATE}`,
    component: SubscribeValidate,
    exact: false,
  },
  {
    //no ssr required in this
    path: `${URL_PATH.PRODUCTSUBSCRIBEVALIDATE}`,
    component: ProductSubscribeValidate,
    exact: false,
  },
  // {
  //   path: `${URL_PATH.WHATSAPP_SERVICE}`,
  //   component: Whatsapp,
  //   exact: true,
  //   loadData: [getWhatsAppService],
  // },
  {
    path: `${URL_PATH.UPDATES_NOTIFICATION}`,
    component: UpdatesNotifications,
    exact: true,
    loadData: null,
  },
  {
    path: `${URL_PATH.MF_BYTES}`,
    component: MfBytes,
    exact: true,
  },
  {
    path: `${URL_PATH.MAINTENANCE}`,
    component: Maintenance,
    exact: true,
  },
  // Start About Us
  {
    path: `${URL_PATH.ABOUT_US_NEW}`,
    component: AboutUsNew,
    exact: true,
  },
  {
    path: `${URL_PATH.CORPORATE_PROFILE}`,
    component: CorporateProfile,
  },
  {
    path: `${URL_PATH.CORPORATE_GOVERNANCE}`,
    component: CorporateGovernance,
  },
  {
    path: `${URL_PATH.FINANCIAL_INFORMATION}`,
    component: FinancialInformation,
    loadData: [getAboutUsFinancialInfo],
  },
  {
    path: `${URL_PATH.MEDIA_CENTER}`,
    component: MediaCenter,
  },
  {
    path: `${URL_PATH.LEADERSHIP_PROFILE}`,
    component: LeadershipProfile,
  },
  // End About Us
  // Learners Corners Start
  {
    path: `${URL_PATH.LEARNERS_CORNERS}`,
    component: LearnersCorners,
    exact: true,
  },
  {
    path: `${URL_PATH.LEARNERS_BEGINNER}`,
    component: LearnerFinencialAwareness,
    exact: true,
    loadData: [learnCornerLevels],
  },
  {
    path: `${URL_PATH.LEARNERS_INTERMEDIATE}`,
    component: LearnerFinencialAwareness,
    exact: true,
    loadData: [learnCornerLevels],
  },
  {
    path: `${URL_PATH.LEARNERS_ADVANCED}`,
    component: LearnerFinencialAwareness,
    exact: true,
    loadData: [learnCornerLevels],
  },

  {
    path: `${URL_PATH.IAP_DOWNLOADS}`,
    component: InvestorAwarenessProgram,
  },

  // {
  //   path: `${URL_PATH.INVESTOR_AWARENESS_PROGRAMMES}`,
  //   component: InvestorAwarenessProgram,
  // },
  // {
  //   path: `${URL_PATH.KEY_REDRESSAL_COMPLAINTS}`,
  //   component: InvestorAwarenessProgram,
  // },
  // {
  //   path: `${URL_PATH.MF_BYTES_APP}`,
  //   component: InvestorAwarenessProgram,
  // },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_VIDEOS}`,
    component: LearnersCornersVideos,
    exact: true,
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_VIDEOS_DETAILS}`,
    component: LearnersCornersVideosdetails,
    exact: true,
    loadData: [cornerVideodetailApi],
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_PODCAST}`,
    component: LearnersCornersPodcasts,
    exact: true,
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_PODCAST}/:url`,
    component: LearnersCornersPodcastDetails,
    exact: true,
    loadData: [getCornerPodcastDetails]
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_IMPACT_INFLATIONS}`,
    component: LearnersCornersimpactInflations,
    exact: true,
    loadData: [getCalculatorMetaData],
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_SIP_CALCULATOR}`,
    component: LearnersCornersSipCalculators,
    exact: true,
    loadData: [getCalculatorMetaData],
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_PRESENT_VALUES}`,
    component: LearnersCornersPresentValues,
    exact: true,
    loadData: [getCalculatorMetaData],
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_GOALSIP}`,
    component: LearnersCornersGoalSip,
    exact: true,
    loadData: [getCalculatorMetaData],
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_TOPUPSIP}`,
    component: LearnersCornersTopUpSip,
    exact: true,
    loadData: [getCalculatorMetaData],
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_STPCALCULATOR}`,
    component: LearnersCornersStpCalculator,
    exact: true,
    loadData: [getCalculatorMetaData],
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_SWAPCALCULATOR}`,
    component: LearnersCornersSwapCalculators,
    exact: true,
    loadData: [getCalculatorMetaData],
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_RETIREMENTCALCULATOR}`,
    component: LearnersCornersRetirementCalculator,
    exact: true,
    loadData: [getCalculatorMetaData],
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_COSTOFCHILDEDUCATION}`,
    component: LearnersCornersCostOfChildEducation,
    exact: true,
    loadData: [getCalculatorMetaData],
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_DREAMSIP}`,
    component: LearnersCornersDreamSip,
  },
  {
    path: `${URL_PATH.LEARNERS_TOOLS}`,
    component: LearnersTools,
    exact: true,
  },
  {
    path: `${URL_PATH.LEARNERS_CORNERS_BOOK_REVIEW}`,
    component: BookReview,
    exact: true,
    loadData: [getBookReview],
  },
  //learners information start
  {
    path: `${URL_PATH.BEGINNERINFO}`,
    component: BeginnerDetailInfo,
    exact: true,
    loadData: [BeginnerDetail],
  },
  {
    path: `${URL_PATH.INTERMEDIATEINFO}`,
    component: IntermediateDetailInfo,
    exact: true,
    loadData: [IntermediateDetail],
  },
  {
    path: `${URL_PATH.ADVANCEINFO}`,
    component: AdvanceDetailInfo,
    exact: true,
    loadData: [AdvanceDetail],
  },
  {
    path: `${URL_PATH.BOOK_REVIEW_INFO}`,
    component: BookreviewInformation,
    exact: true,
    loadData: [getBookReviewDetails],
  },
  {
    path: `${URL_PATH.THE_READING_ROOM}`,
    component: ReadingRoom,
    exact: true,
  },
  {
    path: `${URL_PATH.THE_POETRYSEC_SEC}`,
    component: Poetrysec,
    exact: true,
  },
  //learners information start
  // Learners Corners End
  
  // Start product solution
  {
    path: `${URL_PATH.PRODUCT_SOLUTIONS}`,
    component: ProductSolutions,
    exact: true,
    loadData: [getAllFundProducts]
  },
  {
    path: `${URL_PATH.COMPAREFUNDS}`,
    component: CompareFunds,
  },
  {
    path: `${URL_PATH.COMPAREFUNDSDETAILS}`,
    component: CompareFundsDetails,
  },
  {
    path: `${URL_PATH.FLEXI_CAP_PROMOTION}`,
    component: FlexiCapPromotion,
  },
  {
    path: `${URL_PATH.FLEXI_CAP_PROMOTION_QUICK_LINK}`,
    component: FlexiCapPromotionQuicklink,
  },
  {
    path: `${URL_PATH.PRODUCT_OVERVIEW}`,
    component: ProductOverview,
    loadData: [getSingleFundDetails],
  },
  {
    path: `${URL_PATH.NFO_OVERVIEW}`,
    component: NfoOverview,
    loadData: [getNfoOverview],
  },
  // End product solution
  //StatutoryDisclosure start
  {
    path: `${URL_PATH.STATUTORY_DISCLOSURE}`,
    component: StatutoryDisclosure,
    exact: true,
  },
  {
    path: `${URL_PATH.MANDATORY_INVESTMENT_AMC}`,
    component: MandatoryInvestmentByAMC,
  },

  {
    path: `${URL_PATH.DISCLOSURE_OF_VARIOUS_PAYMENT}`,
    component: DisclosureOfVariousPayment,
  },
  {
    path: `${URL_PATH.DISCLOSURE_OF_DESIGNATED_EMPLOYEES}`,
    component: DisclosureofDesignatedEmployees,
  },
  {
    path: `${URL_PATH.DISCLOSURE_OF_VARIOUS_PURPOSE}`,
    component: DisclosureofVariousPurpose,
  },
  {
    path: `${URL_PATH.REPORT_OF_COMPLIANCE_STEWARDSHIP_CODE}`,
    component: ReportOfComplianceOfStewardshipCode,
  },
  {
    path: `${URL_PATH.RATIONAL_FOR_DEVIATION}`,
    component: RationaleforDeviation,
  },
  {
    path: `${URL_PATH.ANNUAL_DISCLOSURE_OF_RISKOMETERS}`,
    component: AnnualDisclosureofRiskometers,
  },
  {
    path: `${URL_PATH.ANNUAL_REPORT}`,
    component: AnnualReport,
  },
  {
    path: `${URL_PATH.ABRIDGED}`,
    component: Abridged,
  },
  {
    path: `${URL_PATH.SCHEME_FINANCIALS}`,
    component: SchemeFinancials,
  },
  {
    path: `${URL_PATH.MONTHLY_PORTFOLIO}`,
    component: MonthlyPortfolioNEW,
  },
  {
    path: `${URL_PATH.AVERAGE_PORTFOLIO}`,
    component: AveragePortfolio,
  },
  {
    path: `${URL_PATH.AUM}`,
    component: Aum,
  },
  {
    path: `${URL_PATH.TRADE}`,
    component: Trade,
  },
  {
    path: `${URL_PATH.COMISSION}`,
    component: Comission,
  },
  {
    path: `${URL_PATH.STAT_UNCLAIMED_DIVIDEND_REDEMPTION}`,
    component: UnclaimedDividendRedemptionNew,
  },
  {
    path: `${URL_PATH.TOTAL_EXPENSE_RATIO_OF_MUTUAL_FUND_SCHEMES}`,
    component: TotalExpenseRatioOfMurualFundSchemes,
  },
  {
    path: `${URL_PATH.STAT_TRACKING_ERROR}`,
    component: TrackingErrorNew,
  },
  {
    path: `${URL_PATH.VOTING}`,
    component: Voting,
  },
  {
    path: `${URL_PATH.STEWARDSHIP_REPORT}`,
    component: StewardshipReport,
  },
  {
    path: `${URL_PATH.REMUNERATION_NEW}`,
    component: Remunerationnew,
  },
  {
    path: `${URL_PATH.SCHEME_PERFORMANCE_NEW}`,
    component: SchemePerformancenew,
  },
  {
    path: `${URL_PATH.INVESTOR_COMPLAINTS}`,
    component: InvestorComplaints,
  },
  {
    path: `${URL_PATH.INVESTOR_COMPLAINTS_PMS}`,
    component: InvestorComplaintsPms,
  },  
  {
    path: `${URL_PATH.STATUTORY_COMPLAINTS}`,
    component: Complaints,
  },
  {
    path: `${URL_PATH.LETTER_UNITHOLDER}`,
    component: LetterUnitholder,
  },
  {
    path: `${URL_PATH.STAT_PUBLIC_CAUTION_NOTICE}`,
    component: PublicCautionNew,
  },
  {
    path: `${URL_PATH.OFFER_DOCUMENT}`,
    component: OfferDocuments,
  },
  {
    path: `${URL_PATH.ADVISORY_DISCLOSURE}`,
    component: AdvisoryDisclosure,
  },
  {
    path: `${URL_PATH.DISTRIBUTOR_COMMISSION}`,
    component: DistributorCommission,
  },
  {
    path: `${URL_PATH.MARKET_MAKERS}`,
    component: MarketMakers,
  },
  {
    path: `${URL_PATH.DISCLOSURENEW}`,
    component: Disclosurenew,
  },
  {
    path: `${URL_PATH.RISK_ADJUSTED_RETURN}`,
    component: RiskAdjustedReturn,
  },
  {
    path: `${URL_PATH.REPORT_ON_MISSELLING}`,
    component: ReportOnMisselling,
  },
  {
    path: `${URL_PATH.STATUTORY_INFORMATION_DETAIL}`,
    component: StatutoryInfoDetail,
    exact: true,
    loadData: [getStatutoryInfoDetailContent],
  },
  //StatutoryDisclosure end
  //distributor Corner Start
  {
    path: `${URL_PATH.DISTRIBUTOR_CORNER}`,
    component: DistributorCornerNew,
    exact: true,
  },
  {
    path: `${URL_PATH.BEING_A_MFD}`,
    component: BeingaMFD,
  },
  {
    path: `${URL_PATH.ONBOARD_DIGITALLY}`,
    component: OnboardDigitally,
  },
  {
    path: `${URL_PATH.FORMS_DISCLOSURE}`,
    component: FormsDisclosures,
  },
  {
    path: `${URL_PATH.KNOWLEDGE_CENTER}`,
    component: KnowledgeCentre,
  },
  {
    path: `${URL_PATH.FAQS}`,
    component: FAQs,
  },
  {
    path: `${URL_PATH.SEBI_CODE_OF_CONDUCT}`,
    component: SebiCodeofConduct,
  },
  {
    path: `${URL_PATH.HANDBOOK}`,
    component: HandBook,
    exact: true,
  },
  {
    path: `${URL_PATH.HANDBOOK}/:url`,
    component: HandBookDetail,
    exact: true,
    loadData: [getHandBookDetails]
  },
  {
    path: `${URL_PATH.DISTRIBUTOR_INFORMATION_DETAIL}`,
    component: DistributorInfoDetail,
    exact: true,
    loadData: [getDistributorInfoDetailContent],
  },
  //distributor corner end

  //Start Investor Service

  {
    path: `${URL_PATH.INVESTOR_SERVICES}`,
    component: InvestorServices,
    exact: true,
  },
  {
    path: `${URL_PATH.FORM_AND_DISCLOSURES}`,
    component: FormsandDisclosures,
  },
  {
    path: `${URL_PATH.OUR_ONLINE_SERVICES}`,
    component: OurOnlineServices,
  },
  {
    path: `${URL_PATH.ADDITIONAL_FUND_INFO}`,
    component: AdditionalFundInformation,
    exact: true,
  },
  {
    path: `${URL_PATH.FACTSHEETS}`,
    component: Factsheets,
  },
  {
    path: `${URL_PATH.FUND_DOCUMENTS}`,
    component: FundDocuments,
  },
  {
    path: `${URL_PATH.FUND_LITERATURES}`,
    component: FundLiteratures,
  },

  {
    path: `${URL_PATH.INVESTOR_MARKET_UPDATE}`,
    component: InvestorMarketUpdate,
    exact: true,
  },
  {
    path: `${URL_PATH.INVESTOR_MARKET_UPDATE_TABS}`,
    component: InvestorMarketUpdate,
    exact: true,
  },
  {
    path: `${URL_PATH.INVESTOR_MARKET_VIDEO_DETAIL}`,
    component: MarketVideoDetail,
    exact: true,
    loadData : [getMarketVideoDetail],
  },
  {
    path: `${URL_PATH.INVESTOR_FAQ}`,
    component: InvestorFaq,
    loadData: [getInvestorFaq],
  },
  {
    path: `${URL_PATH.SCHEME_COLLECTION}`,
    component: SchemeCollectionAccount,
  },
  {
    path: `${URL_PATH.WEEKLY_PORTFOLIO_DETAILS}`,
    component: WeeklyPortfolioDetails,
  },
  {
    path: `${URL_PATH.INVESTOR_INFORMATION_DETAIL}`,
    component: InvestorServiceInfoDetail,
    exact: true,
    loadData: [getInvestorInfoDetailContent],
  },
  //End INvestor Service

  //Knowledge Stack start
  {
    path: `${URL_PATH.KNOWLEDGE_STACK}`,
    component: KnowledgeStack,
    exact: true,
  },

  {
    path: `${URL_PATH.NEW_MD_INSIGHTS}`,
    component: NewMDCeoDesk,
    exact: true,
  },
  // {
  //   path: `${URL_PATH.MD_SPEAKS_ARTICLES}`,
  //   component: Articles,
  //   exact: true,
  // },
  // {
  //   path: `${URL_PATH.MD_SPEAKS_VIDEOS}`,
  //   component: Videos,
  //   exact: true,
  // },
  {
    path: `${URL_PATH.MD_SPEAKS_VIDEOS_DETAILS}`,
    component: MdspeakVideosDetail,
    exact: true,
    loadData: [mdVideosDetails],
  },
  // {
  //   path: `${URL_PATH.MD_MEDIA_ARTICLES}`,
  //   component: InterviewArticles,
  //   exact: true,
  // },
  // {
  //   path: `${URL_PATH.MD_MEDIA_VIDEOS}`,
  //   component: InterviewVideos,
  //   exact: true,
  // },
  // {
  //   path: `${URL_PATH.MD_MEDIA_VIDEOS_DETAILS}`,
  //   component: InterviewVideosDetail,
  //   exact: true,
  //   loadData: [mdInterviewVideosDetail],
  // },
  {
    path: `${URL_PATH.MARKET_REVIEW}`,
    component: MarketReview,
    exact: true,
  },
  {
    path: `${URL_PATH.CREDIT_POLICY}`,
    component: CreditPolicy,
    exact: true,
  },
  {
    path: `${URL_PATH.MF_YEARBOOK}`,
    component: MFYearbook,
    exact: true,
  },
  {
    path: `${URL_PATH.TUESDAYS_TALKING_POINTS}`,
    component: TuesdayTalkingPoint,
    exact: true,
  },
  {
    path: `${URL_PATH.CHART_SCOPE}`,
    component: ChartScope,
    exact: true,
  },
  {
    path: `${URL_PATH.MF_INSIGHTS}`,
    component: MfInsights,
    exact: true,
  },
  {
    path: `${URL_PATH.WEEKEND_BYTES}`,
    component: WeekendBytes,
    exact: true,
  },
  {
    path: `${URL_PATH.MUSINGS}`,
    component: Musings,
    exact: true,
  },
  {
    path: `${URL_PATH.SALES_HANDBOOK}`,
    component: SalesHandbook,
    exact: true,
    loadData: [getKnowledgestackHandbook]
  },
  {
    path: `${URL_PATH.WEBINARS}`,
    component: Webinars,
    exact: true,
  },
  {
    path: `${URL_PATH.WEBINARS}/:url`,
    component: WebinarDetail,
    loadData: [getWebinarDetail]
  },
  {
    path: `${URL_PATH.VIDEOS_MEDIA}`,
    component: VideoList,
  },
  {
    path: `${URL_PATH.PODCASTS_MEDIA}`,
    component: Podcasts,
  },
  {
    path: `${URL_PATH.BEHAVIOURAL_BLOGS}`,
    component: BehaviouralBlogs,
    exact: true,
  },

  //detail
  {
    path: `${URL_PATH.TALKING_DETAILINFO}`,
    component: TalkingDetailInfo,
    exact: true,
    loadData: [getKnowledgestackTalkingDetail],
  },
  {
    path: `${URL_PATH.WEEKEND_DETAILINFO}`,
    component: WeekendDetailInfo,
    exact: true,
    loadData: [getKnowledgestackWeekendBytesDetail],
  },
  {
    path: `${URL_PATH.MONTHLY_DETAILINFO}`,
    component: MonthlyDetailInfo,
    exact: true,
    loadData: [getKnowledgestackMonthlyMusingDetail],
  },
  {
    path: `${URL_PATH.CREDITPOLICY_DETAILINFO}`,
    component: CreditPolicyDetailInfo,
    exact: true,
    loadData: [getKnowledgestackCreaditPolicyDetail],
  },
  {
    path: `${URL_PATH.MDSPEAK_ARTICLE_DETAILINFO}`,
    component: MdspeakarticleDetailInfo,
    exact: true,
    loadData: [getMDSpeakArticleDetail],
  },
  {
    path: `${URL_PATH.BEHAVIOURAL_BLOG_DETAILINFO}`,
    component: BehaviouralBlogDetailInfo,
    exact: true,
    loadData: [getKnowledgestackBehaviouralBlog],
  },
  {
    path: `${URL_PATH.MARKET_REVIEW_DETAILINFO}`,
    component: MarketReviewDetailInfo,
    exact: true,
    loadData: [getMarketReviewDetail],
  },

  //Knowledge Stack end
  // Goal Marketing start
  {
    path: `${URL_PATH.GOAL_MARKETING}`,
    component: GoalMarketing,
    exact: true,
  },
  // Goal Marketing end
  // {
  //   path: `${URL_PATH.HOMEPAGE}`,
  //   component: Homepage,
  //   exact: true,
  //   loadData: [getHome],
  // },
  {
    path: `${URL_PATH.HOMEPAGE}`,
    component: HomePageNew,
    exact: true,
  },
  //IAP Page start
  {
    path: `${URL_PATH.IAP_PAGE}`,
    component: IAPPage,
    exact: true,
    loadData: [iapPageData]
  },
  //IAP Page End
  
  {
    path: `${URL_PATH.GOALS}`,
    component: Goals,
    exact: true,
  },
  {
    path: `${URL_PATH.GOALS}/:goalId`,
    component: Goals,
    exact: true,
  },
  {
    path: `${URL_PATH.KNOW_YOUR_INVESTMENT_PERSONALITY}`,
    component: RiskProfiler,
    exact: true,
  },
  {
    path: `${URL_PATH.INVESTMENT_BASKET}`,
    component: ProductSolutions,
    exact: true,
  },
  {
    path: `${URL_PATH.PRODUCT_SOLUTIONS}/:url`,
    component: InvestmentBasketDetail,
    exact: true,
    loadData:[allSectionsMeta]
  },
  {
    path: `${URL_PATH.ACCOUNT_STATEMENT}`,
    component: AccountStatement,
    exact: true,
  },
  {
    path: `${URL_PATH.SIP_LANDING}`,
    component: SipLanding,
    exact: true,
  },
  // Important Announcement start
  {
    path: `${URL_PATH.IMMPORTANT_ANNOUNCEMENT}`,
    component: ImmportantAnnouncement,
    exact: true,
  },
  // Important Announcement end
  // GlossarySec start
  {
    path: `${URL_PATH.GLOSSARY_SEC}`,
    component: GlossarySec,
    exact: true,
  },
  // GlossarySec End
  // IAP women start
  {
    path: `${URL_PATH.IAP_WOMEN_ENGLISH}`,
    component: IAPWomenEnglish,
    exact: true,
  },
  {
    path: `${URL_PATH.EMAIL_MODAL}`,
    component: EmailPopup,
    exact: true,
  },
  {
    path: `${URL_PATH.EMAIL_MODAL_EVENTS}`,
    component: EmailPopupEvents,
    exact: true,
  },
  {
    path: `${URL_PATH.EMAIL_MODAL_HINDI}`,
    component: EmailPopupHindi,
    exact: true,
  },
  {
    path: `${URL_PATH.IAP_REGISTRATION}`,
    component: IAPWomenRegistration,
    exact: true,
  },
  {
    path: `${URL_PATH.IAP_QUIZ_REGISTRATION}`,
    component: IAPQuizRegistration,
    exact: true,
  },
  // IAP women end
  // Survey Start
  {
    path: `${URL_PATH.FINANCIAL_TRANSACTION}`,
    component: SurveyFT,
    loadData: [SurveyUser]
  },
  {
    path: `${URL_PATH.NON_FINANCIAL_TRANSACTION}`,
    component: SurveyNFT,
    loadData: [SurveyUser]
  },
  {
    path: `${URL_PATH.PARTNER_SURVEY}`,
    component: SurveyPartner,
    loadData: [SurveyUser]
  },
  // Survey End
  // Jan Nivesh Start
  {
    path: `${URL_PATH.JAN_NIVESH}`,
    component: JanNivesh,
  },
  // Jan Nivesh End
  //youtubeshorts start
  {
    path: `${URL_PATH.YOUTUBE_SHORTS}`,
    component: HomeYoutubeShorts,
    exact: true,
    loadData: [getYoutubeShorts],
  },
  //youtubeshorts end
  //OneSpan start
  {
    path: `${URL_PATH.ONESPAN}`,
    component: OneSpan,
    exact: true,
  },
  {
    path: `${URL_PATH.ONESPANIOS}`,
    component: OneSpan,
    exact: true,
  },
  //OneSpan end
  {
    path: `${URL_PATH.PAGE_NOT_FOUND}`,
    component: PageNotFound,
  },
];
